import {mixins} from "../app/mixin";

mixins.push({
    el: '.co2nnectorPage',
    mounted() {
        const widgetId = localStorage.getItem('widget_id');

        if (widgetId) {
            this.widgetId = widgetId;
        }

        this.calcWidgetCode();
    },
    data() {
        return {
            calculatorAPI: window.calculatorAPI,
            dijikolayWidgetChannel: window.dijikolayWidgetChannel,
            widgetChannel: window.widgetChannel,
            isCodeCopied1: false,
            isCodeCopied2: false,
            widgetId: '',
            widgetCode: '&lt;co2nsensus-widget widget-id="xxxxxxxx-xxxxx-xxxxx-xxxxxxxx" classes="light"></co2nsensus-widget>'
        }
    }, methods: {
        async copyWidgetText(widgetId) {
            let textToCopy

            async function copyToClipboard() {
                try {
                    await navigator.clipboard.writeText(textToCopy)
                } catch (err) {
                    console.error(err)
                }
            }

            if (widgetId === 1) {
                textToCopy = document.getElementById('code1').textContent
                this.isCodeCopied1 = true
                setTimeout(() => {
                    this.isCodeCopied1 = false
                }, 3000)
            }
            if (widgetId === 2) {
                if (!this.widgetId) {
                    this.widgetId = await this.createWidgetId()
                }
                textToCopy = `<co2nsensus-widget widget-id="${this.widgetId}" classes="light"></co2nsensus-widget>`

                this.isCodeCopied2 = true
                setTimeout(() => {
                    this.isCodeCopied2 = false
                }, 3000)
            }
            copyToClipboard()
        }, async createWidgetId() {
            let params = (new URL(document.location)).searchParams;
            let name = params.get("ref");

            const response = await fetch(`${this.calculatorAPI}/widgets/co2nnector`, {
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    channel: name === 'diji_kolay' || name === 'DIJI_KOLAY' ? this.dijikolayWidgetChannel : this.widgetChannel,
                    menus: [1, 2, 3, 4, 5, 6],
                    widgetUrl: 'public',
                })
            });

            const json = await response.json();
            this.widgetId = json.id;

            localStorage.setItem('widget_id', this.widgetId);

            this.calcWidgetCode();
        },
        calcWidgetCode() {
            this.widgetCode = '&lt;co2nsensus-widget widget-id="' + (this.widgetId ? this.widgetId : 'xxxxxxxx-xxxxx-xxxxx-xxxxxxxx') + '" classes="light"></co2nsensus-widget>';
        }
    }
});
